import React from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const OfferAgreement = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#0a0c0e',
      padding: '20px'
    }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        {/* Кнопка назад */}
        <Button
          onClick={handleBack}
          style={{
            background: 'transparent',
            color: '#e8e8e8',
            border: '2px solid #1a472a',
            marginBottom: '30px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          icon={<ArrowLeftOutlined />}
        >
          Назад
        </Button>

        {/* Заголовок */}
        <h1 style={{
          color: '#e8e8e8',
          fontSize: '28px',
          fontWeight: '700',
          marginBottom: '30px',
          textAlign: 'center'
        }}>
          Договор-оферта
        </h1>

        {/* Контент */}
        <div style={{
          background: '#0f1113',
          border: '2px solid #1a472a',
          borderRadius: '12px',
          padding: '30px',
          color: '#e8e8e8',
          lineHeight: '1.6'
        }}>
          <h2 style={{ color: '#1a472a', marginBottom: '20px' }}>
            1. Общие положения
          </h2>
          <p style={{ marginBottom: '20px' }}>
            Настоящий договор-оферта (далее — «Договор») определяет условия использования 
            сервиса проверки подлинности изделий LimitVerify (далее — «Сервис»).
          </p>

          <h2 style={{ color: '#1a472a', marginBottom: '20px' }}>
            2. Предмет договора
          </h2>
          <p style={{ marginBottom: '20px' }}>
            Сервис предоставляет возможность проверки подлинности изделий путем ввода 
            идентификационного номера изделия и получения информации о его статусе.
          </p>

          <h2 style={{ color: '#1a472a', marginBottom: '20px' }}>
            3. Права и обязанности сторон
          </h2>
          <p style={{ marginBottom: '20px' }}>
            Пользователь обязуется использовать Сервис в соответствии с его назначением 
            и не нарушать права третьих лиц. Администрация Сервиса обязуется обеспечивать 
            корректную работу Сервиса и защиту персональных данных пользователей.
          </p>

          <h2 style={{ color: '#1a472a', marginBottom: '20px' }}>
            4. Ответственность
          </h2>
          <p style={{ marginBottom: '20px' }}>
            Администрация Сервиса не несет ответственности за точность информации, 
            предоставленной производителями изделий, и за возможные убытки, 
            возникшие в результате использования Сервиса.
          </p>

          <h2 style={{ color: '#1a472a', marginBottom: '20px' }}>
            5. Заключительные положения
          </h2>
          <p style={{ marginBottom: '20px' }}>
            Договор вступает в силу с момента начала использования Сервиса. 
            Администрация оставляет за собой право изменять условия Договора 
            с уведомлением пользователей.
          </p>

          <div style={{
            marginTop: '30px',
            padding: '20px',
            background: '#0a0c0e',
            borderRadius: '8px',
            border: '1px solid #1a472a'
          }}>
            <p style={{ margin: 0, fontSize: '14px', color: '#b5b9bf' }}>
              <strong>Дата последнего обновления:</strong> {new Date().toLocaleDateString('ru-RU')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferAgreement;
